<div class="open-close-form">

    <div class="prediction-data-wrapper">
        <div class="section-element "><div class="main-section-title">Select prediction by...</div></div>
        <div class="section-element column run-selector">
            <div class="section-title">Run date:</div>
            <div class="selection-block prediction-date-container">
                <app-prediction-selector 
                  [runs]="runsData()"
                  [isLoading]="isPredictionLoading"
                  [isDisabled]="isFieldDisabled()"
                  [placeholder]="'Select a prediction by run date'"
                  (selectionChange)="onRunSelected($event)">
                </app-prediction-selector>
            </div>
        </div>

        <div class="section-element column run-calendar">
            <div class="section-title">Manual selection:</div>
            <div class="date-picker-container ">
                <!-- <label>Run date</label> -->
                <p-datepicker 
                  appendTo="body"
                  [(ngModel)]="runDate" 
                  [showIcon]="true" 
                  [showOnFocus]="false" 
                  inputId="buttondisplay"
                  placeholder="Set run date" 
                  [disabled]="isFieldDisabled()"
                  (onSelect)="onRunDateChange($event)"/>
            </div>
        </div>

        <div class="section-element column run-calendar">
            <div class="section-title">Scenario:</div>
            <div class="scenario-container ">
                <!-- <label>Run date</label> -->
                <p-select 
                *ngIf="!isPredictionLoading"
                [options]="followedScenarioDropdown()" 
                [(ngModel)]="selectedFollowedScenario" 
                optionLabel="description" 
                [disabled]="isScenarioFieldDisabled"
                (onChange)="onFollowedScenarioChange($event)"></p-select>
                <div class="loading-block" *ngIf="isPredictionLoading"><fa-icon  [icon]="faSpinner" class="spinner-icon fa-spin-pulse"></fa-icon></div>

            </div>
        </div>

        <div class="scenario-name-input control-container input-field" *ngIf="!isScenarioNameDisabled">
            <div class="label-and-input">
                <label>Scenario name</label>
                <div class="input-container">
                    <input 
                    type="text" 
                    id="scenario_name" 
                    [ngClass]="{ 'invalid-input': scenarioNameNotValid() }"
                    [(ngModel)]="scenarioName" 
                    (input)="onScenarioNameChange($event)"
                    maxlength="100" />
                </div>
            </div>
            <small [ngClass]="{ 'visible': scenarioNameNotValid() }">Scenario name is required</small>
        </div>

        
        <div class="section-element-validation predicted-price-container">
            <div class="label-and-input">
                <div class="section-title">Predicted price:</div>
                <div class="price-container ">
                    <div class="input-container">
                        <div class="intro-div">$</div><input [disabled]="isPredictedPriceDisabled" [ngClass]="{ 'invalid-input': predictedPriceNotValid() }" type="number" id="manual-predicted-price" [(ngModel)]="predictedPrice" (input)=" validatePredictedPrice($event)"  maxlength="12" size="3" />
                    </div>
                </div>

            </div>
            <small [ngClass]="{ 'visible': predictedPriceNotValid() }">Must be a valid numeric value</small>
         
        </div>
    </div>

    <div class="trade-data-wrapper">
        <div class="left">
            <div class="section-element"><div class="main-section-title">Open trade data</div></div>
            <div class="section-element row open-trade-calendar">
                <div class="section-title">Trade date:</div>
                <div class="date-picker-container ">
                    <!-- <label>Run date</label> -->
                    <p-datepicker 
                      appendTo="body"
                      [(ngModel)]="tradeDate" 
                      [showIcon]="true" 
                      [showOnFocus]="false" 
                      inputId="buttondisplay"
                      placeholder="Set trade date" 
                      [disabled]="isFieldDisabled()"
                      (onSelect)="onTradeDateChange($event)"/>
                </div>
            </div>
            <div class="section-element-validation trade-price input-field">
                <div class="label-and-input">
                    <div class="section-title">Trade price:</div>
                    <div class="price-container input-container"><span>$</span><input 
                        [ngClass]="{ 'invalid-input': tradePriceNotValid() }"
                        [disabled]="isFieldDisabled()"
                        type="number" id="manual-predicted-price" 
                        [(ngModel)]="tradePrice" 
                        (input)=" validateTradePrice($event)" 
                        maxlength="12" size="3" /></div>
                </div>
                <small [ngClass]="{ 'visible': tradePriceNotValid() }">Must be a valid numeric value</small>
                
            </div>     
            
            <div class="section-element row direction">
                <div class="section-title">(visibility:hidden)</div>
                <div class="radiobuttons-container">
                    <div class="field-radiobutton">
                        <p-radioButton name="option" value="short"   [disabled]="isFieldDisabled()" [(ngModel)]="selectedDirection" inputId="short" (ngModelChange)="onDirectionChange()"/>
                        <label for="short">Short</label>
                      </div>
                      
                      <div class="field-radiobutton">
                        <p-radioButton name="option" value="long"   [disabled]="isFieldDisabled()" [(ngModel)]="selectedDirection" inputId="long" (ngModelChange)="onDirectionChange()"/>
                        <label for="long">Long</label>
                      </div>
                      
                </div>

            </div>  

            <div class="section-element row contract">
                <div class="section-title">Contract:</div>
                <div class="contract-dropdown-container">
                    <p-select [options]="monthsDropdown()" 
                    [disabled]="isFieldDisabled()"
                    [(ngModel)]="selectedMonth" 
                    optionLabel="description" 
                    (onChange)="onMonthDropdownChange($event)"></p-select>

                    <p-select [options]="yearsDropdown()" 
                    [disabled]="isFieldDisabled()"
                    [(ngModel)]="selectedYear" 
                    optionLabel="description" 
                    (onChange)="onYearDropdownChange($event)"></p-select>
                </div>

            </div>  

            <div class="section-element-validation lots input-field">
                <div class="label-and-input">
                    <div class="section-title">Lots/contracts:</div>
                    <div class="lots-container input-container"><input type="number" step="1"
                        [ngClass]="{ 'invalid-input': lotsInputNotValid() }"
                        [disabled]="isFieldDisabled()"
                        id="manual-predicted-price" [(ngModel)]="lots" 
                        (keydown)="preventDecimalInput($event)" (input)=" validateLotsQty($event)" 
                         maxlength="12" size="3" /></div>
                  
                </div>
                <small [ngClass]="{ 'visible': lotsInputNotValid() }">Must be a valid numeric value</small>
     
            </div>  
        </div>
        <div class="divider"> <p-divider layout="vertical"></p-divider></div>
       
        <div class="right">
            <div class="section-element row"><div class="main-section-title">Closing trade data</div></div>
            <div class="section-element row closing-trade-calendar">
                <div class="section-title">Closing date:</div>
                <div class="date-picker-container ">
                    <!-- <label>Run date</label> -->
                    <p-datepicker 
                      appendTo="body"
                      [(ngModel)]="closingDate" 
                      [showIcon]="true" 
                      [showOnFocus]="false" 
                      inputId="buttondisplay"
                      placeholder="Set closing date" 
                      [disabled]="isFieldDisabled()"
                      (onSelect)="onClosingDateChange($event)"/>
                </div>

              
            </div>
            <div class="section-element-validation closing-price">
                <div class="label-and-input">
                    <div class="section-title">Closing price:</div>
                    <div class="price-container input-container"><span>$</span><input 
                        [disabled]="isFieldDisabled()"
                        [ngClass]="{ 'invalid-input': closingPriceNotValid() }"
                        type="number" id="manual-predicted-price" 
                        [(ngModel)]="closingPrice" 
                        (input)=" validateClosingPrice($event)" 
                        maxlength="12" size="3" /></div>
    
                </div>
              
                <small [ngClass]="{ 'visible': closingPriceNotValid() }">Must be a valid numeric value</small>
                
            </div>  

            <div class="section-element row closing-reason">
                <div class="section-title">Closing reason:</div>
                <div class="radio-buttons-wrapper">
                    <div class="field-radiobutton">
                        <p-radioButton  [disabled]="isFieldDisabled()" name="option" value="profit_taking" [(ngModel)]="closingReasonModel" inputId="profit_taking" (ngModelChange)="onReasonChange()"/>
                        <label for="take_profit">Profit taking</label>
                    </div>
                  
                    <div class="field-radiobutton">
                        <p-radioButton  [disabled]="isFieldDisabled()" name="option" value="stop_loss" [(ngModel)]="closingReasonModel" inputId="stop_loss" (ngModelChange)="onReasonChange()"/>
                        <label for="stop_loss">Stop loss</label>
                    </div>

                </div>

            </div>  
        </div>
    </div>

    <div class="comments-wrapper">
        <div class="section-element row"><div class="main-section-title">Additional comments:</div></div>
        <div class="section-element row free-text-container">
            <textarea pInputTextarea [(ngModel)]="freeText"
            [disabled]="isFieldDisabled()"
            (input)=" validateFreeText($event)"
            rows="10" cols="30" placeholder="Enter your comments here..."></textarea>

        </div>
    </div>
</div>
